import {
    AutoshipExistingSubscriberContent,
    AutoshipFirstTimeEligibleContent,
    AutoshipMapRestrictedContent,
} from './AutoshipDynamicContent';
import { getAutoshipDrawerDiscountMessage, isSkuMapRestricted } from './lib';

type AutoshipInfoDrawerHeaderProps = {
    discountDisplay?: string;
    isFirstAutoshipEligible: boolean;
};

export const AutoshipInfoDrawerHeader = ({
    discountDisplay,
    isFirstAutoshipEligible,
}: AutoshipInfoDrawerHeaderProps) => {
    if (isSkuMapRestricted(discountDisplay)) {
        return <AutoshipMapRestrictedContent />;
    }

    const { discount, maxSavings } = getAutoshipDrawerDiscountMessage({
        discountDisplay,
        isFirstAutoshipEligible,
    });

    if (isFirstAutoshipEligible) {
        return <AutoshipFirstTimeEligibleContent discount={discount} maxSavings={maxSavings} />;
    }

    return <AutoshipExistingSubscriberContent discount={discount} maxSavings={maxSavings} />;
};
